import { Folder } from "../../redux/interfaces/folder.types.ts";

export const hasLeaseContract = (folder: Folder): boolean => {
  const templates =
    folder.subfolders?.map((subfolder) => subfolder.template) ||
    folder.templates;
  return !!templates
    ?.flat()
    .some((template) => template.slug?.toLowerCase().includes("lease"));
};
